import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'

const PublicPresentationReducer = combineReducers({
  fetchPresentationRequest: createRequestReducer('PUBLIC_PRESENTATION:FETCH', {
    pending: true
  }),
  copyingPresentationRequest: createRequestReducer('PUBLIC_PRESENTATION:COPY'),
  presentation: createReducer(null, {
    'PUBLIC_PRESENTATION:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.presentation,
    'PUBLIC_PRESENTATION:SET_RECOMMENDED_REQUEST_SUCCESS': (
      state,
      { params }
    ) => ({
      ...state,
      recommended_until: params.date
    })
  })
})

export default PublicPresentationReducer
